// Cell renderer used to show number of files attached to action item for the client-side row model ActionItemsGrid
// NOTE: "link" only shows tooltip
import React from "react"
import { Tooltip } from "antd"
import PropTypes from "prop-types"

const ActionItemDocsCSRM = ({ value }) => {
  if (!value || value?.length === 0) return <span className="action-item-text">0</span>

  return (
    <Tooltip title={value.join(", ")}>
      <a className="action-item-text tooltip-link">{value.length}</a>
    </Tooltip>
  )
}

ActionItemDocsCSRM.propTypes = {
  value: PropTypes.arrayOf(PropTypes.string),
}

export default ActionItemDocsCSRM
